import axios from 'axios';

export const getLastModifiedDate = async (): Promise<string> =>{
    try {
        const response = await axios.get(`/api/version/lastModified`);        
        return response.data;
    } catch (error) {
        console.error('Error fetching last modified date:', error);
        throw error;
    }
}
